var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex h-full bg-pure-white", attrs: { id: "reports" } },
    [
      _c(
        "div",
        { staticClass: "flex flex-col flex-grow pt-2" },
        [
          _c(
            "div",
            {
              staticClass:
                "sticky z-50 flex items-center justify-between top-18 left-6 h-18 bg-pure-white",
              style: { width: "calc(100vw - 3rem - 0.5rem)" },
              attrs: { id: "report-title" }
            },
            [
              _c(
                "div",
                { staticClass: "flex items-center gap-2" },
                [
                  _c("BlTextTitle4", { attrs: { text: "Reports" } }),
                  _vm._v(" "),
                  _c("BlBubbleCount", {
                    attrs: { count: _vm.totalReports || 0 }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex items-center gap-2" },
                [
                  _c("BlSort", {
                    attrs: {
                      options: _vm.sortOptions,
                      defaultValue: _vm.defaultSort,
                      dropDirection: "left"
                    },
                    on: {
                      change: function($event) {
                        return _vm.onChangeSort($event)
                      }
                    },
                    model: {
                      value: _vm.sortInput,
                      callback: function($$v) {
                        _vm.sortInput = $$v
                      },
                      expression: "sortInput"
                    }
                  }),
                  _vm._v(" "),
                  _c("BlInputButton", {
                    attrs: { icon: "plus", label: "Create report" },
                    on: {
                      clicked: function($event) {
                        return _vm.$modal.show("modal-create-report")
                      }
                    }
                  })
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c("NewReportModal"),
          _vm._v(" "),
          _vm.fetchLoading
            ? _c("div", { staticClass: "grid h-128 place-items-center" }, [
                _c("div", { staticClass: "blum-loader" })
              ])
            : !_vm.reports.length
            ? _c(
                "div",
                {
                  staticClass:
                    "flex flex-col items-center justify-center w-full text-center h-128"
                },
                [
                  _c("BlTextBody1", {
                    attrs: {
                      text:
                        "Currently, there are no report to display. Once you create a"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex items-center justify-center gap-2 text-center"
                    },
                    [
                      _c("BlTextBody1", {
                        attrs: { text: "new report, it will appear here." }
                      }),
                      _vm._v(" "),
                      _c("BlInputButton", {
                        staticClass: "p-0",
                        attrs: { label: "Create a new report.", type: "plain" },
                        on: {
                          clicked: function($event) {
                            return _vm.$modal.show("modal-create-report")
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _c(
                "div",
                { staticClass: "mb-4" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "sticky z-20 flex items-center rounded-t top-36",
                      attrs: { id: "credit-header" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "sticky left-0 z-10 flex pl-6 bg-pure-white"
                        },
                        [
                          _c(
                            "BlTooltip",
                            {
                              staticClass:
                                "flex items-center flex-shrink-0 h-12 px-4 border-t border-l rounded-tl w-14 bg-slate-300 border-slate-400"
                            },
                            [
                              _c("BlInputCheck", {
                                attrs: {
                                  checked: _vm.checked,
                                  indeterminate: _vm.indeterminate
                                },
                                on: { changed: _vm.changeSelectedAll }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "BlTooltip",
                            {
                              staticClass:
                                "flex items-center flex-shrink-0 h-12 px-4 border-t border-r w-60 bg-slate-300 border-slate-400"
                            },
                            [
                              _c("BlTextSubtitle3", {
                                staticClass: "truncate",
                                attrs: { text: "Report name" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "BlTooltip",
                        {
                          staticClass:
                            "flex items-center flex-shrink-0 w-40 h-12 px-4 border-t bg-slate-300 border-slate-400"
                        },
                        [
                          _c("BlTextSubtitle3", {
                            staticClass: "truncate",
                            attrs: { text: "Status" }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "BlTooltip",
                        {
                          staticClass:
                            "flex items-center flex-shrink-0 w-56 h-12 px-4 border-t bg-slate-300 border-slate-400"
                        },
                        [
                          _c("BlTextSubtitle3", {
                            staticClass: "truncate",
                            attrs: { text: "Date range" }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "BlTooltip",
                        {
                          staticClass:
                            "flex items-center flex-shrink-0 w-56 h-12 px-4 border-t bg-slate-300 border-slate-400"
                        },
                        [
                          _c("BlTextSubtitle3", {
                            staticClass: "truncate",
                            attrs: { text: "Template used" }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "BlTooltip",
                        {
                          staticClass:
                            "flex items-center flex-shrink-0 h-12 px-4 border-t w-50 bg-slate-300 border-slate-400"
                        },
                        [
                          _c("BlTextSubtitle3", {
                            staticClass: "truncate",
                            attrs: { text: "Created by" }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "BlTooltip",
                        {
                          staticClass:
                            "flex items-center flex-shrink-0 h-12 px-4 border-t w-50 bg-slate-300 border-slate-400"
                        },
                        [
                          _c("BlTextSubtitle3", {
                            staticClass: "truncate",
                            attrs: { text: "Last updated" }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "BlTooltip",
                        {
                          staticClass:
                            "flex items-center flex-shrink-0 h-12 px-4 border-t w-50 bg-slate-300 border-slate-400"
                        },
                        [
                          _c("BlTextSubtitle3", {
                            staticClass: "truncate",
                            attrs: { text: "Updated by" }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "sticky right-0 z-10 flex flex-grow pr-6 bg-pure-white"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex items-center flex-grow flex-shrink-0 h-12 px-4 border-t border-r rounded-tr w-60 bg-slate-300 border-slate-400"
                            },
                            [_c("BlTextSubtitle3", { attrs: { text: "" } })],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.reports, function(report, idx) {
                    return _c("ClientReportItem", {
                      key: report.id,
                      attrs: {
                        report: report,
                        checked: _vm.selectedReport.includes(report.id),
                        isLast: idx + 1 === _vm.reports.length
                      },
                      on: {
                        "change-selected": function($event) {
                          return _vm.changeSelected(report.id)
                        }
                      }
                    })
                  }),
                  _vm._v(" "),
                  _vm.totalReports > 25
                    ? _c(
                        "div",
                        { staticClass: "flex mb-36" },
                        [
                          _c("BlInputPagination", {
                            staticClass: "mt-6",
                            style: { width: "calc(100vw - 3rem - 0.5rem)" },
                            attrs: {
                              page: _vm.page,
                              perPage: _vm.perPage,
                              total: _vm.totalReports
                            },
                            on: {
                              changed: _vm.changePage,
                              "changed-per-page": _vm.changePerPage
                            }
                          })
                        ],
                        1
                      )
                    : _c("div", { staticClass: "mb-46" })
                ],
                2
              )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "fixed z-50 flex items-center justify-between w-full gap-2 px-6 py-2 transition-all duration-500 bg-white border rounded shadow-lg min-h-16 max-w-200 border-slate-400",
          class: [_vm.selectedReport.length ? "bottom-16" : "-bottom-16"],
          style: {
            left: "50%",
            transform: "translateX(-50%)"
          }
        },
        [
          _c(
            "div",
            { staticClass: "flex items-center gap-2 truncate" },
            [
              _c("BlInputButton", {
                attrs: { type: "plain", icon: "close" },
                on: {
                  clicked: function($event) {
                    _vm.selectedReport = []
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "truncate" },
                [
                  _c("BlTextSubtitle3", {
                    staticClass: "text-slate-800",
                    attrs: {
                      text: _vm.selectedReport.length + " report(s) selected"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.selectedReport.length
            ? _c(
                "div",
                { staticClass: "flex items-center gap-2" },
                [
                  _c("BlInputButton", {
                    attrs: {
                      label: "Delete (" + _vm.selectedReport.length + ")",
                      type: "outlined-error",
                      dense: "",
                      loading: _vm.deleteLoading
                    },
                    on: {
                      clicked: function($event) {
                        _vm.deleteOpened = true
                      }
                    }
                  }),
                  _vm._v(" "),
                  _vm.downloadable
                    ? _c("BlInputButton", {
                        attrs: {
                          label: "Download (" + _vm.selectedReport.length + ")",
                          dense: "",
                          loading: _vm.downloadLoading
                        },
                        on: { clicked: _vm.onDownloadSelected }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _vm.deleteOpened
        ? _c(
            "BlBackdrop",
            {
              attrs: {
                title: "Delete report",
                label: "Delete " + _vm.selectedReport.length + " report(s)",
                type: "error",
                disabled: _vm.deleteLoading
              },
              on: {
                "backdrop-close": function($event) {
                  _vm.deleteOpened = false
                },
                "backdrop-action": _vm.onDeleteSelected
              }
            },
            [
              _c(
                "div",
                { staticClass: "px-4 lg:px-8" },
                [
                  _c(
                    "div",
                    [
                      _c("BlTextBody2", {
                        attrs: {
                          text:
                            "You are about to delete the following report from your client:"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.selectedReportNames, function(name, idx) {
                    return _c(
                      "div",
                      {
                        key: idx,
                        staticClass: "flex items-center gap-2 px-2",
                        attrs: { title: _vm.text }
                      },
                      [
                        _c("div", {
                          staticClass:
                            "flex-shrink-0 w-1 h-1 rounded bg-slate-800"
                        }),
                        _vm._v(" "),
                        _c("BlTextBody2", {
                          staticClass: "truncate",
                          attrs: { text: name }
                        })
                      ],
                      1
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c("BlTextBody2", {
                        attrs: {
                          text:
                            "Are you sure you want to proceed? This action is irreversible. "
                        }
                      })
                    ],
                    1
                  )
                ],
                2
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-619012b6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-619012b6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/clients/ClientReport.vue
// module id = null
// module chunks = 